import { createStore } from 'owa-satcheljs';
import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';

interface CategorySortStore {
    categoryByRowKey: Map<string, string>;
}

const defaultStore: CategorySortStore = {
    categoryByRowKey: new Map<string, string>([]),
};

const mailboxInfoToCategorySortStore = new Map<string, CategorySortStore>();

export const getStore = (mailboxInfo: MailboxInfo): CategorySortStore => {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const name = accountKey + '_categorySortStore';
    let cachedStore = mailboxInfoToCategorySortStore.get(name);
    if (!cachedStore) {
        /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
         *	> Function should only be invoked in module scope */
        const store = createStore<CategorySortStore>(name, defaultStore)();
        mailboxInfoToCategorySortStore.set(name, store);
        cachedStore = store;
    }
    return cachedStore;
};
